import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const { customer } = ZuAuthStore();

  // If not logged, redirect to /home
  // Or, render the public route (without layout)
  // return customer ? <Navigate to="/home" replace /> : <Outlet />;

  return <Outlet />;
};

export default PublicRoute;
